"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnerArticleApiClient = void 0;
const shared_logger_1 = require("@aladin/shared-logger");
const shared_common_sdk_1 = require("@aladin/shared-common-sdk");
function createPartnerArticleApiClient(options) {
    const logger = options.logger ?? shared_logger_1.NOOP_LOGGER;
    const client = (0, shared_common_sdk_1.createAxiosClient)(options.partnerArticleApiHost, {
        accessTokenSource: options.accessTokenSource,
    });
    async function createArticle(partnerId, article) {
        try {
            const response = await client.post(`/v2/partners/${partnerId}/articles`, article);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function findAllArticlesByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/articles`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function findOneArticleByPartnerIdAndSlug(partnerId, slug) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/articles/${slug}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    // returns nothing with status_code : 204
    async function updateArticleByPartnerIdAndSlug(partnerId, slug, article) {
        try {
            const response = await client.post(`/v2/partners/${partnerId}/articles/${slug}`, article);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function deleteArticle(partnerId, slug) {
        try {
            const response = await client.delete(`/v2/partners/${partnerId}/articles/${slug}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function findAnchoredArticleByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v2/partners/${partnerId}/anchored-article`);
            return response.data;
        }
        catch (err) {
            if (err.response.status === 404)
                return null;
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    return {
        createArticle,
        findAllArticlesByPartnerId,
        findOneArticleByPartnerIdAndSlug,
        updateArticleByPartnerIdAndSlug,
        deleteArticle,
        findAnchoredArticleByPartnerId,
    };
}
exports.createPartnerArticleApiClient = createPartnerArticleApiClient;
//# sourceMappingURL=data:application/json;base64,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